import React from 'react';
import '@/pages/Home.scss';
import Hero from '@/components/sections/Hero';
import amsterdam from '@/assets/nightshots/amsterdam.jpg';
import dublin from '@/assets/nightshots/dublin.jpg';
import lisbon from '@/assets/nightshots/lisbon.jpeg';
import manchester from '@/assets/nightshots/manchester.jpeg';
import VentureTiles from '@/components/sections/VentureTiles';
import Intro from '@/components/sections/Intro';
import ImageBanner from '@/components/sections/ImageBanner';

const locations = [
  {
    title: 'Lisbon',
    img: lisbon,
    path: '/ventures/real-estate#lisbon',
    label: 'ATLANTIC BEAUTY with Ephemera',
  },
  {
    title: 'Amsterdam',
    img: amsterdam,
    path: '/ventures/real-estate#amsterdam',
    label: 'CANALSIDE ELEGANCE with Ephemera',
  },
  {
    title: 'Dublin',
    img: dublin,
    path: '/ventures/real-estate#dublin',
    label: 'METROPOLITAN CHARM with Ephemera',
  },
  {
    title: 'Manchester',
    img: manchester,
    path: '/ventures/real-estate#manchester',
    label: 'INDUSTRIAL LUXE with Ephemera',
  },
];

const Home: React.FC = () => {
  return (
    <main className="home">
      <Hero />
      <Intro />
      <VentureTiles />

      <section id="locations" className="image-banner-list">
        {locations.map(loc => (
          <ImageBanner
            key={loc.title}
            city={loc.title}
            image={loc.img}
            path={loc.path}
            label={loc.label}
          />
        ))}
      </section>
    </main>
  );
};

export default Home;
